// extracted by mini-css-extract-plugin
export default {"main":"AboutRedirect_main__qynhE","button":"AboutRedirect_button__IqTKn"};